import * as React from 'react'

interface IProps {
  value: number
  step?: number
  min?: number
  max?: number
  numberFormatter?: (value: number) => string
  onChange(newValue: number)
}

export default class NumberSelector extends React.Component<IProps> {
  public static defaultProps = {
    step: 1,
    numberFormatter: value => String(value),
  }

  public render() {
    const { value, numberFormatter } = this.props
    const displayedValue = numberFormatter(value)
    return (
      <div className="tw:inline-block tw:pr-[15px] tw:relative tw:text-body-md tw:text-foreground">
        {displayedValue}
        <span
          className="tw:absolute tw:w-0 tw:h-0 tw:border-x-[3px] tw:border-x-transparent tw:border-b-[6px] tw:border-b-muted-foreground tw:right-0.5 tw:cursor-pointer tw:top-0.5"
          onClick={this.incrementNumber}
        />
        <span
          className="tw:absolute tw:w-0 tw:h-0 tw:border-x-[3px] tw:border-x-transparent tw:border-t-[6px] tw:border-t-muted-foreground tw:right-0.5 tw:cursor-pointer tw:bottom-0.5"
          onClick={this.decrementNumber}
        />
      </div>
    )
  }

  private incrementNumber = () => {
    const { value, step, max, onChange } = this.props
    const newValue = value + step
    if (!max || newValue <= max) {
      onChange(newValue)
    }
  }

  private decrementNumber = () => {
    const { value, step, min, onChange } = this.props
    const newValue = value - step
    if (!min || newValue >= min) {
      onChange(newValue)
    }
  }
}
